
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/grade-summary/jst/group';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  return "\n        class=\"has-mastery\"\n      ";
  }

function program3(depth0,data) {
  
  
  return "\n        class=\"no-mastery\"\n      ";
  }

  buffer += "<div id=\"group_header-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"group-description\" role='button' tabindex='0' aria-controls=\"group_detail-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-expanded='false'>\n  <label class=\"screenreader-only\" for=\"group_header-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'mastery_count': ((depth0 && depth0.mastery_count)),
    'count': ((depth0 && depth0.count)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("grade_summary.group")
  },data:data},helper ? helper.call(depth0, "expand_collapse_title_outcome_group_student_meets__46ffef48", "Expand/collapse %{title} Outcome Group, student meets mastery of %{mastery_count} of %{count} outcomes", options) : helperMissing.call(depth0, "t", "expand_collapse_title_outcome_group_student_meets__46ffef48", "Expand/collapse %{title} Outcome Group, student meets mastery of %{mastery_count} of %{count} outcomes", options)))
    + "\n  </label>\n  <div class=\"outcome-icon\">\n    <i class=\"icon-mini-arrow-down collapsed-arrow\"></i>\n    <i class=\"icon-mini-arrow-up expanded-arrow\"></i>\n  </div>\n  <h3 class=\"group-title\" aria-hidden=\"true\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h3>\n  <div class=\"group-status\" aria-hidden=\"true\">\n    <ul class=\"pill\">\n      <li\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.mastery_count), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        >"
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.mastery_count), options) : helperMissing.call(depth0, "n", (depth0 && depth0.mastery_count), options)))
    + "</li>\n      <li>"
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.count), options) : helperMissing.call(depth0, "n", (depth0 && depth0.count), options)))
    + "</li>\n    </ul>\n  </div>\n</div>\n<div id=\"group_detail-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"outcomes\">\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  